/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import {Form, FormGroup, FormText} from 'react-bootstrap';
import Props from './Props';
import CenteredPanel from '../CenteredPanel';
import {MessageType} from '../../model/messageType';
import styles from './styles';
import {css} from 'aphrodite/no-important';

class CenteredFormPanel extends React.Component<Props> {

	static defaultProps: Props = {
		children: undefined,
		message: '',
		messageType: MessageType.INFO,
		title: ''
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<CenteredPanel title={props.title}>
				<Form action="#" method="POST" autoComplete="on" onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
					event.preventDefault();
					return false;
				}}>
					{props.message &&

					<FormGroup controlId="message">
						<FormText as="div" className={css(props.messageType === 'ERROR' && styles.errorMessage)}>{props.message}</FormText>
					</FormGroup>}
					{props.children}
				</Form>
			</CenteredPanel>
		);
	}

}

export default CenteredFormPanel;
